import * as React from 'react';

import { GenericError, IGenericErrorProps } from '@opendoor/cinderblocks/platform/GenericError';

import Layout from '../components/Layout';

class NotFound extends React.PureComponent<IGenericErrorProps> {
  public render() {
    return <Layout renderContent={this.renderContent} renderNav={this.renderNav} />;
  }

  public renderContent = () => (
    <GenericError
      errorContent="The requested page doesn’t exist. Sorry about that."
      headerContent="Oops, wrong address."
    />
  );
  public renderNav = () => null;
}

export default NotFound;
